import {observer} from "mobx-react"
import {PageContentTitle} from "../../ui"
import {cmsRuleCreateStore, DialogStore, growlStore} from "../../../store"
import {useNavigate} from "react-router";
import {CmsRuleForm, CmsRuleFormData} from "./CmsRuleForm";
import {useState} from "react";

const CmsRuleCreatePage = observer(function CmsDetailPage() {
    const navigate = useNavigate()
    const [cancelDialog] = useState(new DialogStore())
    const display = `Neue Regel anlegen`

    const {
        name,
        field,
        value,
        action,
    } = cmsRuleCreateStore

    const data: CmsRuleFormData = {
        name,
        field,
        value,
        action,
    }

    const dirty = cmsRuleCreateStore.dirty
    const valid = cmsRuleCreateStore.valid

    return  <>
        <PageContentTitle
            actions={[
                {
                    label: 'Speichern',
                    cls: `is-primary ${cmsRuleCreateStore.saving ? 'is-loading' : ''}`,
                    disabled: !(dirty && valid),
                    action: async () => {
                        const id = await cmsRuleCreateStore.create()
                        cmsRuleCreateStore.reset()
                        growlStore.add({
                            message: 'Die Regel wurde erfolgreich hinzugefügt',
                            autoclose: true,
                            closable: true
                        })
                        navigate(`/cms/${cmsRuleCreateStore.customerId}/scan-document-rule/${id}`)
                    }
                },
                {
                    label: 'Verwerfen',
                    cls: 'is-primary is-outlined',
                    disabled: cmsRuleCreateStore.saving || !cmsRuleCreateStore.dirty,
                    action: async () => {
                        cancelDialog.dialogOpen = true
                    }
                },
            ]}
        >{display}</PageContentTitle>
        <CmsRuleForm
            mode={'create'}
            saving={cmsRuleCreateStore.creating}
            data={data}
            validate={async () => {
                await cmsRuleCreateStore.validate()
            }}
            onChange={val => {
                const {
                    name,
                    field,
                    value,
                    action,
                } = val
                cmsRuleCreateStore.name = name
                cmsRuleCreateStore.field = field
                cmsRuleCreateStore.value = value
                cmsRuleCreateStore.action = action
            }}
        />
    </>
})

export {
    CmsRuleCreatePage
}
